var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"explain"},[_c('div',{staticClass:"use"},[_c('greentitle',{attrs:{"titleText":"使用说明"}}),_vm._m(0)],1),_c('div',{staticClass:"use mt-50"},[_c('greentitle',{attrs:{"titleText":"退票规则"}}),_vm._m(1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('p',[_vm._v("请到码头窗口领取纸质票，验纸票二维码登船。")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('p',[_vm._v("游船票一经售出不允许退票。")])])
}]

export { render, staticRenderFns }